const GSA = () => {
    return (
        <div>
  
            <div className="flex flex-col justify-center items-center">
                {/* <hr className="w-[50rem] mx-auto"/> */}
                <hr className="w-full lg:w-[50rem] md:w-[46rem]  mx-[auto] md:mx-[auto]"/>
                <div className="lg:flex md:flex sm:flex grid flex-1 justify-center items-start mx-auto lg:max-w-[50rem] md:max-w-[46rem] sm:max-w-[43rem] my-[5rem] gap-14">
                
                <div className="flex flex-col justify-center">
                    <h1 className="font-bold lg:text-3xl text-2xl text-[#373737]">
                        GSA
                    </h1>
                    <p className="text-sm text-md  lg:max-w-[25rem] md:w-[24rem] sm:w-[19rem] mt-[1rem]">
                        TCS General Sales Agency allows airlines to achieve a cost-effective presence in markets where it may 
                        be uneconomical for an airline to maintain its own sales force and premises. TCS with its strategically 
                        distributed nationwide hubs provides the freight forwarding community with the full range of cargo services.
                    </p>
                  
                    
                </div>
                <div className="flex-1 flex flex-col justify-center sm:mt-[0rem] mt-[1rem]">
                    <img src="/aviation/aviationgsa.jpg" alt="" className="max-w-[100%] rounded-md"/>
                </div>
                </div>
            
            </div>


        </div>
    

    
    )
};
export default GSA;